import React from 'react';
import { cn } from '@/lib/utils';

const LOGO_SRC = '/logo.webp';

export const Logo = ({ className }) => {
  return (
    <img
      src={LOGO_SRC}
      alt="Indilabs — Innovate, Automate, Accelerate"
      className={cn('h-9 w-auto select-none sm:h-11', className)}
      draggable={false}
    />
  );
};
